export const nigmetova = {
  id: 'nigmetova',
  name: {
    ru: 'Нигметова Асемгуль Алтаевна',
    kz: 'Нигметова Асемгуль Алтаевна',
  },
  position: {
    ru: 'Главная медицинская сестра',
    kz: 'Бас мейіргер',
  },
  image: "/team_photoes/new/Нигметова Асемгуль Алтаевна.svg", // Update if actual image is different
  experience: {
    ru: '10 лет',
    kz: '10 жыл',
  },
  education: {
    ru: 'Высшее образование. Специальность: Бакалавр сестринского дела. Учебное заведение: АО «Медицинский университет Астана», г. Астана. Годы обучения: 2007–2011',
    kz: 'Жоғары білім. Мамандық: Мейірбике ісінің бакалавры. Оқу орны: АО «Астана медициналық университеті», Астана қаласы. Оқу жылдары: 2007–2011',
  },
  certificates: {
    ru: 'Вторая квалификационная категория',
    kz: 'Екінші біліктілік санаты',
  },
  work: {
    ru: 'С 2011 года — участковая медсестра в поликлинике города Астана. В настоящее время — главная медсестра в ГККП «Спортивный медицинский центр города Астаны».',
    kz: '2011 жылдан бастап — Астана қаласының емханасында учаскелік мейірбике. Қазіргі уақытта — ГККП «Астана қаласының Спорттық медициналық орталығы» бас мейіргері.',
  },
};
